const groupResultsByLatLng = args => {
  const { groups, results } = args;
  results.forEach(result => {
    const key = `${result.latitude},${result.longitude}`;
    if (groups.hasOwnProperty(key)) {
      groups[key].push(result);
    } else {
      groups[key] = [ result ];
    }
  });
};

export { groupResultsByLatLng };